import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { PercentualShipping } from '../../../../../typings'
import { ReviewProps } from './constants'
import { messages } from './messages'

export function PercentualShippingRecap(props: ReviewProps) {
  const { config } = props
  const { formatPercentual } = useNumbers()

  if (!config.benefit || !config.scope) return null

  const { benefit, scope } = config

  return (
    <FormattedMessage
      {...messages.percentualShipping}
      values={{
        b: (content) => <Text variant="action1">{content}</Text>,
        discount: formatPercentual((benefit as PercentualShipping).value),
        applyTo: scope.applyTo,
      }}
    />
  )
}
